interface TextBoxLayoutInput {
  textWidth: number
  textHeight: number
  minWidth?: number
  paddingX: number
  paddingY: number
  borderWidth: number
  scale: number
}

interface TextBoxLayoutOutput {
  contentWidth: number
  contentHeight: number
  fullWidth: number
  fullHeight: number
  textX: number
  textY: number
  buffer: number
}

export function computeTextBoxLayout({
  textWidth,
  textHeight,
  minWidth = 0,
  paddingX,
  paddingY,
  borderWidth,
  scale
}: TextBoxLayoutInput): TextBoxLayoutOutput {
  const scaledPaddingX = paddingX * scale
  const scaledPaddingY = paddingY * scale
  const scaledBorderWidth = borderWidth * scale
  const buffer = Math.ceil(scaledBorderWidth) + 2

  const contentWidth = Math.max(textWidth + 2 * scaledPaddingX, minWidth * scale)

  const contentHeight = textHeight + 2 * scaledPaddingY

  const fullWidth = contentWidth + 2 * buffer
  const fullHeight = contentHeight + 2 * buffer

  const textX = buffer + (contentWidth - textWidth) / 2
  const textY = buffer + (contentHeight - textHeight) / 2

  return {
    contentWidth,
    contentHeight,
    fullWidth,
    fullHeight,
    textX,
    textY,
    buffer
  }
}
